import { EXTRALARGE } from "shared/variables";
import { Heading3 } from "components/Heading3";
import { IconDownArrow } from "components/Icons";
import { Link } from "components/Link";
import { MaxWidth } from "components/MaxWidth";
import { SrcSet } from "components/SrcSet";
import styles from "./ItemsList.module.css";

export const ItemsList = ({ title, items, imageSizes, withBorderTop }) => (
  <MaxWidth size={EXTRALARGE}>
    <div className={withBorderTop ? styles.borderTopContainer : ""}>
      {title && <Heading3 as="h2">{title}</Heading3>}
      <div className={styles.itemContainer}>
        {items.map((item) => (
          <Item key={item.title} imageSizes={imageSizes} {...item} />
        ))}
      </div>
    </div>
  </MaxWidth>
);

const Item = ({ cropCenter, image, imageSizes, link, text, title }) => (
  <Link className={styles.item} field={link}>
    {image.src && (
      <div className={styles.imageContainer}>
        <SrcSet
          alt={image.alt}
          cropCenter={cropCenter}
          sizes={imageSizes}
          src={image.src}
        />
        <div className={styles.arrow}>
          <IconDownArrow />
        </div>
      </div>
    )}
    <h3 className={styles.title}>{title}</h3>
    <p className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
  </Link>
);
